export default "__VITE_ASSET__bf52e975__"